import PrimaryButton from 'components/form/buttons/primaryButton';

import * as S from './styles';

interface IProps {
  // -- //
  data?: any;
}

/*
 * The counts strip this component is named for is commented out — five tiles
 * reading a `ticketStatistics` call that was never wired up. What it actually
 * renders is the screen's one action, so that is all it draws now.
 */
const PlusIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round">
    <path d="M12 5v14M5 12h14" />
  </svg>
);

export default function SurveyCounts({ data }: IProps) {
  return (
    <S.Content>
      <PrimaryButton link="/panel/survey/create">
        <PlusIcon />
        New survey
      </PrimaryButton>
    </S.Content>
  );
}
